import { Banco } from '../classes/banco';

export namespace BancoBi {

    export class Parser {
        public static fill(origin: any): Banco {
            return Object.assign(new Banco(), origin);
        }

        public static fillList(origin: any): Array<Banco> {
            const items: Array<Banco> = [];
            for (const item of origin) {
                items.push(Parser.fill(item));
            }
            return items;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/resources/bi/banco.bi.ts